// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a24a50e8","732":"96528f1f","977":"02bf82c7"}[chunkId] + ".chunk.js";
};